// https://date-fns.org/docs/parse
import parse from 'date-fns/parse';
// https://date-fns.org/docs/format
import format from 'date-fns/format';

export default function formatTime(time, timeFormat = 'hh:mm A') {
  const parsedDate = parse('2014-02-11T' + time);
  return format(parsedDate, timeFormat);
}
